import { BusinessDownloadConfig } from '../types';

const marketProfileConfig: BusinessDownloadConfig = {
  'marketProfile-mobile': {
    apiUrl:
      '/api/v1/intelligence_pc/market_profile/mobile_data/downloads_excel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'Metrics',
        type: 'checkboxGroup',
        field: 'metric',
        defaultValue: ['rv', 'dl'],
        options: [
          { label: 'Revenue', value: 'rv' },
          { label: 'Downloads', value: 'dl' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'date_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'date' },
            ],
          },
          {
            label: 'dbi_label_country_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            message: `Aggregated: provide the total value in global scale,instead of the accumulated value of all available markets.
             Aggregated: 提供全球的收入和下载量，并非所有国家及地区的汇总值。`,
            field: 'region_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_genre_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            message: `Aggregated: provide the total value in global scale,instead of the accumulated value of all available markets.
             Aggregated: 提供全球的收入和下载量，并非所有国家及地区的汇总值。`,
            field: 'genre_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'Separated by Genres', value: 'parentGenre' },
              { label: 'Separated by Subgenres', value: 'subGenre' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio',
            options: [],
          },
        ],
      },
    ],
  },
  'marketProfile-stats': {
    apiUrl: '/api/v1/intelligence_pc/marketProfile/detail/statsExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_game_platform',
        type: 'radio',
        field: 'entity_type',
        defaultValue: 'mobile',
        options: [
          { label: 'dbi_mobile_game', value: 'mobile' },
          { label: 'dbi_pc_game', value: 'pc' },
          { label: 'dbi_console_game', value: 'console' },
        ],
      },
      {
        label: 'dbi_genre_profile_data_category',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['operation'],
        options: [
          { label: 'dbi_market_operation_data', value: 'operation' },
          { label: 'dbi_market_by_game', value: 'games' },
          { label: 'dbi_market_by_main_genre', value: 'main_genres' },
          // { label: 'By Sub Genre', value: 'sub_genres' },
          { label: 'dbi_market_by_companies', value: 'companies' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
  'marketProfile-combine': {
    apiUrl: '/api/v1/intelligence_pc/profile/market/metric_list',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metric',
        defaultValue: [],
        options: [],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'date',
            field: 'date_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'date' },
            ],
          },
          {
            label: 'dbi_label_country_settings',
            type: 'radio',
            defaultValue: 'market',
            message: '',
            field: 'region_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_genre_settings',
            type: 'radio',
            defaultValue: 'parentGenre',
            message: '',
            field: 'genre_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_genres', value: 'parentGenre' },
              { label: 'dbi_label_separate_by_sub_genres', value: 'subGenre' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio',
            options: [],
          },
        ],
      },
    ],
  },
};

export default marketProfileConfig;
